<template>
  <nav aria-label="breadcrumb" class="breadcrumb-area">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><router-link to="/">HOME</router-link></li>
      <li class="breadcrumb-item active" aria-current="page">404</li>
    </ol>
  </nav>
  <div class="container">
    <div class="top--section">
      <h1>404 Not Found</h1>
      <p>
				ページが見つかりませんでした<br />
			</p>
			<router-link :to="{ path: '/top'}" class="btn btn-primary">トップページへ戻る</router-link>
    </div>
  </div>
</template>
